export type TFlags = Flags;

export enum Flags {
  PLAN_SUMMARY_TAB = 'planSummaryTab',
  FILTER_MONTHLY_CADENCES = 'filterMonthlyCadences',
  SOURCE_REFRESH = 'sourceRefresh',
  PLAN_FLIGHTED = 'planFlighted',
  PLAN_FLIGHTED_EXTENSION = 'planFlightedExtension',
  IS_SPLIT_DLTR = 'isSplitDLTR',
  IS_ESTIMATOR_ENABLED = 'estimator',
  ESTIMATOR_SPL_ENABLED = 'estimatorSPLEnabled',
  MONTHLY_SPL_ENABLED = 'monthlySPLEnabled',
  MY_CHANGE_HISTORY_TAB = 'myChangeHistoryTab',
  NOTIFICATIONS_ADMIN_TAB = 'notificationsAdminTab',
  NOTIFICATIONS_BELL = 'notificationsBell',
  AC_BANNER_NOTIFICATIONS = 'acBannerNotifications',
  PERFORMANCE_MONTHLY_REPORT_EXPORT = 'performanceMonthlyReportExport',
  NOTIFICATIONS_METADATA = 'notificationsMetadata',
}
